export enum FormIds {
    NAME = 'name',
    EMAIL = 'email',
    PASSWORD = 'password',
    CONFIRM_PASSWORD = 'confirmPassword',
    PRIVACY_ACCEPT = 'privacyAccept',
}
